<app-teams-add-dialog 
[isClassTeams]="false"
/>